import { LoadingView } from 'src/components'
import React, { Suspense } from 'react'
import { PropTypes } from 'prop-types'

export const lazyload = loader => {
  const Chunk = React.lazy(loader)

  // eslint-disable-next-line react/display-name
  return props => (
    <ErrorBoundary>
      <Suspense fallback={<LoadingView isLoading />}>
        <Chunk {...props} />
      </Suspense>
    </ErrorBoundary>
  )
}

/**
 * @see https://reactjs.org/docs/code-splitting.html#error-boundaries
 */
class ErrorBoundary extends React.Component {
  state = { error: undefined }

  static propTypes = {
    children: PropTypes.node,
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  render() {
    const { error } = this.state
    return error ? <LoadingView error={error.toString()} /> : this.props.children
  }
}
